import { render, staticRenderFns } from "./userAppointHelp.vue?vue&type=template&id=ef2890e4&scoped=true&"
import script from "./userAppointHelp.vue?vue&type=script&lang=js&"
export * from "./userAppointHelp.vue?vue&type=script&lang=js&"
import style0 from "./userAppointHelp.vue?vue&type=style&index=0&id=ef2890e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2890e4",
  null
  
)

export default component.exports